import React from 'react';
import { Grid } from '@backstage/ui';
import { EntityLayout } from '@backstage/plugin-catalog';
import {
  EntityOwnershipCard,
  EntityUserProfileCard,
} from '@backstage/plugin-org';
import { EntityWarningContent } from './common/EntityWarningContent';
import { InfoCard, StructuredMetadataTable } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import {
  ANNOTATION_USER_DEPARTMENT,
  ANNOTATION_USER_LOCATION,
  ANNOTATION_USER_ROLE,
  ANNOTATION_USER_TITLE,
} from '@appfolio/backstage-plugin-catalog-common';

export const UserEntity = () => {
  const { entity } = useEntity();
  const e = entityUtil(entity);
  const metadata: Record<string, React.ReactNode> = {
    Department: e.getAnnotation(ANNOTATION_USER_DEPARTMENT),
    Role: e.getAnnotation(ANNOTATION_USER_ROLE),
    Title: e.getAnnotation(ANNOTATION_USER_TITLE),
    Location: e.getAnnotation(ANNOTATION_USER_LOCATION),
  };
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid.Root columns="12" gap="4">
          {EntityWarningContent}
          <Grid.Item colSpan={{ initial: '12', md: '6' }}>
            <EntityUserProfileCard showLinks />
          </Grid.Item>
          <Grid.Item colSpan={{ initial: '12', md: '6' }}>
            <InfoCard title="About">
              <StructuredMetadataTable
                metadata={metadata}
                options={{
                  titleFormat: (title: string) => title,
                }}
              />
            </InfoCard>
          </Grid.Item>
          <Grid.Item colSpan={{ initial: '12', md: '6' }}>
            <EntityOwnershipCard
              entityFilterKind={[
                'API',
                'Component',
                'Domain',
                'Resource',
                'System',
              ]}
              entityLimit={1000}
              relationsType="direct"
            />
          </Grid.Item>
        </Grid.Root>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
